import { sourceDataActions } from './sourceDataSlice.js';
import { LOGIN_SOURCES } from '../../../types/paramsConfig.js';
export const STORAGE_KEY_RETURN_URL = 'linkedinReturnUrl';
export const STORAGE_KEY_LOGIN_SOURCE = 'linkedinLoginSource';
export const safeInitSourceData = (dispatch, loginSource, redirectionUrl) => {
    if (loginSource && loginSource.trim() !== '') {
        sessionStorage.setItem(STORAGE_KEY_LOGIN_SOURCE, loginSource);
    }
    dispatch(sourceDataActions.updateLoginSource(loginSource || LOGIN_SOURCES.OTHER));
    if (redirectionUrl && redirectionUrl.trim() !== '') {
        sessionStorage.setItem(STORAGE_KEY_RETURN_URL, redirectionUrl);
    }
    redirectionUrl &&
        dispatch(sourceDataActions.updateRedirectionUrl(redirectionUrl));
};
//# sourceMappingURL=safeInitSourceData.js.map